export default __webpack_public_path__ + "static/765-b3139bea63599d6c113ed66b1470a3ca.gif";